import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentsTerritories } from "./constants";
import type { GenerativeAiAgentsTerritoriesResult } from "./types";
import { isGenerativeAiAgentsTerritoriesResult } from "./validators";

/**
 * GET handler for the "/generative_ai/agents/territories" endpoint
 */
export const getGenerativeAiAgentsTerritories = reactQueryFetcherAdapter(
  generativeAiAgentsTerritories,
  (signal: AbortSignal, appGroupId: string): Promise<GenerativeAiAgentsTerritoriesResult> => {
    return fetch("/generative_ai/agents/territories", "GET", { app_group_id: appGroupId }, { signal });
  },
  isGenerativeAiAgentsTerritoriesResult
);
